export default [
    {
        path: "/edukasi",
        name: "edukasi",
        component: () => import("@/pages/edukasi/Edukasi.vue"),
        meta: {
            pageTitle: "Edukasi",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: "guest",
            // resource: "pelatihan",
            action: "read",
        },
    },
];
